var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactgrowth = function SvgContactgrowth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "contactgrowth_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15",
    transform: "translate(101.491 34.894)",
    fill: "none",
    d: "M0 0h159.777v125.647H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "contactgrowth_svg__a",
    x: 71,
    y: 3,
    width: 271,
    height: 195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0e133b",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12390",
    fill: "#cdceed"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 259",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(52.523 141.878)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 260",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(57.877 134.008)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 261",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(63.231 126.138)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 262",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(55.107 155.056)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 263",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(60.461 147.186)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 264",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(65.814 139.316)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 265",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(71.168 131.446)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 266",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(76.522 123.577)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 267",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(53.815 148.467)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 268",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(59.169 140.597)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 269",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(64.523 132.727)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 270",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(69.877 124.858)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 271",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(56.399 161.645)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 272",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(61.752 153.775)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 273",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(67.106 145.905)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 274",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(72.46 138.036)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 275",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(77.814 130.166)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 276",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(83.168 122.296)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 277",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(63.044 160.364)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 278",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(68.398 152.495)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 279",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(73.752 144.625)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 280",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(79.106 136.755)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 281",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(84.459 128.885)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 282",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(89.813 121.015)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 283",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(64.336 166.953)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 284",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(69.69 159.083)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 285",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(75.044 151.214)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 286",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(80.397 143.344)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 287",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(85.751 135.474)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 288",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(91.105 127.604)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 289",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(65.628 173.542)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 290",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(70.982 165.673)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 291",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(76.335 157.803)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 292",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(81.689 149.933)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 293",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(87.043 142.063)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 294",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(92.397 134.193)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 295",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(97.75 126.323)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 296",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(72.273 172.262)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 297",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(77.627 164.392)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 298",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(82.981 156.522)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 299",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(88.335 148.652)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 300",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(93.688 140.782)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 301",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(99.042 132.913)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 302",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(104.396 125.043)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 303",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(73.565 178.851)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 304",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(81.482 184.056)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 305",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(89.399 189.262)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 306",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(78.919 170.981)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 307",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(86.836 176.186)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 308",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(94.753 181.392)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 309",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(84.273 163.111)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 310",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(92.19 168.317)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 311",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(100.107 173.522)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 312",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(108.024 178.728)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 313",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(89.626 155.241)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 314",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(97.543 160.447)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 315",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(105.461 165.652)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 316",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(113.378 170.858)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 317",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(121.295 176.064)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 318",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(94.98 147.371)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 319",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(102.897 152.577)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 320",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(110.814 157.783)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 321",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(118.732 162.988)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 322",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(126.649 168.194)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 323",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(100.334 139.501)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 324",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(108.251 144.707)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 325",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(116.168 149.913)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 326",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(124.085 155.118)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 327",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(132.002 160.324)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 328",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(105.688 131.632)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 329",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(113.605 136.837)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 330",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(121.522 142.043)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 331",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(129.439 147.248)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 332",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(80.211 177.57)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 333",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(88.128 182.776)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 334",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(96.045 187.981)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 335",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(85.564 169.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 336",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(93.481 174.906)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 337",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(101.399 180.111)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 338",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(90.918 161.83)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 339",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(98.835 167.036)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 340",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(106.752 172.241)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 341",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(114.67 177.447)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 342",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(96.272 153.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 343",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(104.189 159.166)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 344",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(112.106 164.372)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 345",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(120.023 169.577)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 346",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(101.626 146.091)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 347",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(109.543 151.296)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 348",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(117.46 156.502)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 349",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(125.377 161.707)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 350",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(106.979 138.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 351",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(114.897 143.426)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 352",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(122.814 148.632)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 353",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(130.731 153.838)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 354",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(112.333 130.351)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 355",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(120.25 135.557)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 356",
    cx: 1.309,
    cy: 1.305,
    rx: 1.309,
    ry: 1.305,
    transform: "translate(128.167 140.762)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#contactgrowth_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M310.813 183H96.185A16.223 16.223 0 0 1 80 166.74V28.259A16.222 16.222 0 0 1 96.185 12h214.628A16.222 16.222 0 0 1 327 28.259V166.74A16.223 16.223 0 0 1 310.814 183",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23",
    clipPath: "url(#contactgrowth_svg__b)",
    fill: "none",
    stroke: "#eaeaf7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.831,
    transform: "translate(47.81 4)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 9",
    d: "M101.906 160.126h158.947"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 10",
    d: "M101.906 135.163h158.947"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    d: "M101.906 110.199h158.947"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    d: "M101.906 85.236h158.947"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    d: "M101.906 60.273h158.947"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 14",
    d: "M101.906 35.31h158.947"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30",
    d: "M135.46 161.576h-8.6a2.55 2.55 0 1 0 0 5.1h8.6a2.55 2.55 0 1 0 0-5.1",
    fill: "#eaeaf7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31",
    d: "M135.46 136.612h-8.6a2.55 2.55 0 0 0 0 5.1h8.6a2.55 2.55 0 0 0 0-5.1",
    fill: "#eaeaf7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32",
    d: "M135.46 111.649h-8.6a2.55 2.55 0 1 0 0 5.1h8.6a2.55 2.55 0 0 0 0-5.1",
    fill: "#eaeaf7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33",
    d: "M135.46 61.723h-8.6a2.55 2.55 0 1 0 0 5.1h8.6a2.55 2.55 0 0 0 0-5.1",
    fill: "#eaeaf7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M135.46 86.686h-8.6a2.55 2.55 0 0 0 0 5.1h8.6a2.55 2.55 0 0 0 0-5.1",
    fill: "#eaeaf7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35",
    d: "M135.46 36.76h-8.6a2.55 2.55 0 1 0 0 5.1h8.6a2.55 2.55 0 0 0 0-5.1",
    fill: "#eaeaf7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M79.81 65.717a32 32 0 1 1-32 32 32 32 0 0 1 32-32",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 7.931,
    cy: 7.931,
    r: 7.931,
    transform: "translate(69.085 82.112)",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.199
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M84.572 101.289a9.756 9.756 0 0 0-7.562-3.315",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.137
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M67.11 107.349a9.644 9.644 0 0 1 9.9-9.375m14.661 3.313v11.252m5.628-5.626H86.053",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.137
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "m151.788 166.3 22.388-13.978 22.451 1.991 22.35-48.835 22.439 3.48 22.32-13.095 23.387 1.589 18.365-71.933",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.923
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "m305.4 21-5.085 5.466a1.15 1.15 0 0 0 .585 1.9l7.276 1.67a1.15 1.15 0 0 0 1.356-1.458l-2.192-7.128a1.149 1.149 0 0 0-1.94-.45",
    fill: "#81e6d9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41",
    d: "M251.059 55.274q1.508 0 3 .125",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 42",
    d: "M260.187 56.489c12.858 3.555 23.435 14.992 26.341 35.364",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "6.239 6.239"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M286.904 94.962q.147 1.467.243 2.991",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M174.389 107.215a22.6 22.6 0 0 0-.662 2.925",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M173.374 115.7c.286 13.116 7.673 29.6 18.638 35.744",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5.581 5.581"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M194.53 152.645a18.224 18.224 0 0 0 2.866.869",
    fill: "none",
    stroke: "#373a95",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47",
    d: "M251.779 55.31a20 20 0 1 0-20 20 20 20 0 0 0 20-20",
    fill: "#373a95"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17",
    width: 17.611,
    height: 15.021,
    rx: 1.554,
    transform: "translate(222.973 47.799)",
    fill: "none",
    stroke: "#81e6d9",
    strokeMiterlimit: 10,
    strokeWidth: 1.036
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.036,
    d: "M226.34 51.684h10.877"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.036,
    d: "M226.34 54.274h10.877"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48",
    d: "M228.93 57.382h5.7a1.036 1.036 0 1 1 0 2.072h-5.7a1.036 1.036 0 0 1 0-2.072Z",
    fill: "none",
    stroke: "#81e6d9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.036
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49",
    d: "M287.146 101.781a3.829 3.829 0 1 1 3.829-3.829 3.834 3.834 0 0 1-3.829 3.829",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M287.146 95.123a2.829 2.829 0 1 1-2.829 2.829 2.832 2.832 0 0 1 2.829-2.829m0-2a4.829 4.829 0 1 0 4.829 4.829 4.829 4.829 0 0 0-4.829-4.829",
    fill: "#373a95"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51",
    d: "M197.396 157.344a3.829 3.829 0 1 1 3.829-3.829 3.834 3.834 0 0 1-3.829 3.829",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52",
    d: "M197.396 150.686a2.829 2.829 0 1 1-2.829 2.829 2.832 2.832 0 0 1 2.829-2.829m0-2a4.829 4.829 0 1 0 4.829 4.829 4.829 4.829 0 0 0-4.829-4.829",
    fill: "#373a95"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53",
    d: "M199.716 88.935a20 20 0 1 0-20 20 20 20 0 0 0 20-20",
    fill: "#373a95"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54",
    d: "m186.221 90.869 2.293 1.267c.666.369.666.966 0 1.334l-7.591 4.2a2.773 2.773 0 0 1-2.412 0l-7.592-4.2c-.665-.368-.665-.965 0-1.334l2.294-1.267",
    fill: "none",
    stroke: "#81e6d9",
    strokeMiterlimit: 10,
    strokeWidth: 1.036
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "m186.221 87 2.293 1.268c.666.368.666.965 0 1.333l-7.591 4.2a2.773 2.773 0 0 1-2.412 0l-7.592-4.194c-.665-.368-.665-.966 0-1.334L173.21 87",
    fill: "none",
    stroke: "#81e6d9",
    strokeMiterlimit: 10,
    strokeWidth: 1.036
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56",
    d: "m188.51 85.733-7.591 4.2a2.766 2.766 0 0 1-2.412 0l-7.591-4.2c-.666-.368-.666-.966 0-1.334l7.591-4.2a2.773 2.773 0 0 1 2.412 0l7.591 4.2c.669.368.669.966 0 1.334Z",
    fill: "none",
    stroke: "#81e6d9",
    strokeMiterlimit: 10,
    strokeWidth: 1.036
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57",
    d: "M47.696 60.195a5.261 5.261 0 1 1-5.26 5.26 5.26 5.26 0 0 1 5.26-5.26",
    fill: "#81e6d9",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7965",
    fill: "none",
    d: "M0 0h340v200H0z"
  })));
};
export default SvgContactgrowth;